import { ContextualMenu, IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import d4signIcon from '../../assets/icons/assinatura-eletronica.svg';
import biCopy from '../../assets/icons/bi-copy.svg';
import copyFolderStructureIcon from '../../assets/icons/copy-folder-structure.svg';
import downloadIcon from '../../assets/icons/download.svg';
import draftIcon from '../../assets/icons/draft.svg';
import editIcon from '../../assets/icons/editar.svg';
import deleteicon from '../../assets/icons/excluir.svg';
import moveIcon from '../../assets/icons/mover.svg';
import openAppIcon from '../../assets/icons/open-app.svg';
import releaseIcon from '../../assets/icons/release.svg';
import revisionIcon from '../../assets/icons/revisoes.svg';
import sharedFileIcon from '../../assets/icons/share-compartilhar.svg';
import { TemporalityDocument } from "../../assets/icons/temporalityDocument";
import { ToFile } from '../../assets/icons/toFile';
import unduDraftIcon from '../../assets/icons/unduDraft.svg';
import { useProfile } from "../../context/ProfileProvider/useProfile";
import stylesList from "../../pages/Style/List.module.css";
import { useLessMargin } from "../../pages/WorkSpaceItem/ResizeStyles/ListModuleStyles/LessMargin.css";
import { ReactComponent as ThreeDotsIcon } from '../PDF/PDFViewer/SVG/tres-pontinhos-detalhes.svg';
import { MenuConfig } from "./MenuConfig";
import MenuStiledRenderProps from "./MenuStiledRender";
import starIconSvg from '../../assets/svg/starIconSVg.svg'
import { EnumPermissionTypeNone } from '../../enums/EnumPermissionTypeNone';
import { DOWNLOADABLE_EXTENSIONS, ITEM_TYPE } from '../../helpers/ItemsHelper';
import copy from 'copy-to-clipboard';

const OS_PLATFORM = {
  WINDOWS: 'Win'
};

export interface MenuContProps {
  menuConfig: MenuConfig
}

export interface IElementIcon{
  icon: React.FC<{color:string}>;
  color: string;
}

function MenuCont(props: MenuContProps) {
  const profile = useProfile();
  const { t } = useTranslation();
  const [menuItems, setMenuItems] = useState<IContextualMenuItem[]>([]);
  const linkRef = React.useRef(null);
  const liRef = useRef<HTMLDivElement>(null)
  const [showContextualMenu, setShowContextualMenu] = React.useState(false);
  const onShowContextualMenu = React.useCallback((ev: React.MouseEvent<HTMLElement>) => {
    ev.preventDefault();
    setShowContextualMenu(true);
  }, []);
  const onHideContextualMenu = React.useCallback(() => setShowContextualMenu(false), []);
  const [anchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const documentLinkUrl = window.location.protocol + '//' + window.location.host + '/file/' + props.menuConfig.idItem;
  
  const copyDocumentLinkUrl = () => {
    copy(documentLinkUrl);
    props.menuConfig.setPopupOkMessage(true, t("Copy.message"))
  }

  function isDownloadMenu(extension: undefined|string )
  {
    return extension ? DOWNLOADABLE_EXTENSIONS.has(extension.toLowerCase()) : false;
  }
  
  useEffect(() => {
    const isArchived = props.menuConfig.archiving == true;
    const isFolder = props.menuConfig.itemType === ITEM_TYPE.FOLDER;
    const isFile = props.menuConfig.itemType === ITEM_TYPE.FILE;
    const isAdmin = props.menuConfig.isAdmin;
    const isOwner = props.menuConfig.ownerId == profile.id;
    const isLayoutPendencies = props.menuConfig.layoutPendencies == true;
    const isPermissionTypeEdit = props.menuConfig.permissionType == EnumPermissionTypeNone.edit;
    const isPermissionTypeRead = props.menuConfig.permissionType == EnumPermissionTypeNone.read;
    const isPermissionTypeOrganize = props.menuConfig.permissionType == EnumPermissionTypeNone.organize;
    const isReleaseConst = props.menuConfig.isReleaseConst == true
    const isCurrentUserDraft = profile.id == props.menuConfig.currentUserDraft
    const isEditorCannotSeeRevision = props.menuConfig.currentFolder?.isEditorCannotSeeRevision == true;
    const isUndoDraftIsOpen = props.menuConfig.undoDraftIsOpen == true;
    const isD4SignSignedConst = props.menuConfig.isD4SignSignedConst == true;

    let context:IContextualMenuItem[] = [];
    if(isArchived && (isAdmin || isOwner || isPermissionTypeOrganize)){
      context.push({
        key: 'Desarquivar',
        text: "Desarquivar",
        onClick: props.menuConfig.setArchiving,
        itemProps: {
          style: {
            borderBottom: '1px solid black'
          }
        }
      })
    }
    else {
      if (isLayoutPendencies) {
        if (isFile) {
          if (isDownloadMenu(props.menuConfig.extension)) {
            context.push({
              key: 'Download',
              text: "Download",
              onClick: props.menuConfig.downloadFile,
              onRender: (item) => getMenuStyledRender(item, downloadIcon, props.menuConfig.downloadFile)
                
            })
          }
        }
      }
      else {

        if (props.menuConfig.isFavorite) {
          context.push({
              key: 'favoritar',
              text: t("AdminConsole.Unfavorite"),
              onClick: props.menuConfig.revision,
              onRender: (item) =>
                <MenuStiledRenderProps
                  item={item}
                  widthStandar={true}
                  disabled={false}
                  src={starIconSvg}
                  onClick={() => {props.menuConfig.favorite(); setShowContextualMenu(false)}}
                />
            })
        } else {
          context.push({
              key: 'favoritar',
              text: t("AdminConsole.Favorite"),
              onClick: props.menuConfig.revision,
              onRender: (item) =>
                <MenuStiledRenderProps
                  item={item}
                  widthStandar={true}
                  disabled={false}
                  src={starIconSvg}
                  onClick={() => {props.menuConfig.favorite(); setShowContextualMenu(false)}}
                />
            })
        }

        if (isFile) {
          if (
            (isPermissionTypeOrganize) &&
            (props.menuConfig.validatioRuleConst == undefined || (props.menuConfig.validatioRuleConst != undefined && isReleaseConst))
          ) {
            if (
              (isCurrentUserDraft && !isReleaseConst) ||
              (isReleaseConst)
            ) {

              if (!isReleaseConst && isCurrentUserDraft) {
              context.push({
                key: 'Deletar Draft',
                text: t("Item.deleteBtn"),
                onClick: props.menuConfig.excluir,
                onRender: (item) => getMenuStyledRender(item, deleteicon, props.menuConfig.excluir, undefined, false)
              })
            }
            }

            if (isReleaseConst && (isAdmin || isOwner || isPermissionTypeOrganize)) {
              context.push({
                key: 'Deletar Release',
                text: t("Item.deleteBtn"),
                onClick: props.menuConfig.excluir,
                onRender: (item) => getMenuStyledRender(item, deleteicon, props.menuConfig.excluir)
              })
            }
            
            if(isReleaseConst && props.menuConfig.temporalityDocument != undefined){    
              context.push({
                key: 'Temporalidade',
                text: t("Temporality.message"),
                onClick: props.menuConfig.temporalityDocument,
                onRender: (item) => getMenuStyledRender(item, {icon: TemporalityDocument, color:"rgb(45, 45, 45)"}, props.menuConfig.temporalityDocument)

              })
            }
            
            context.push({
              key: 'Mover',
              text: t("Move.message"),
              onClick: props.menuConfig.moveOpen,
              onRender: (item) => getMenuStyledRender(item, moveIcon, props.menuConfig.moveOpen)
            })
          }

          if (!isEditorCannotSeeRevision) {
              context.push({
                key: 'Revision',
                text: t("Revisao.term"),
                onClick: props.menuConfig.revision,
                onRender: (item) => getMenuStyledRender(item, revisionIcon, props.menuConfig.revision)
              })
            }
  
  
          if (isDownloadMenu(props.menuConfig.extension)) {
            context.push({
              key: 'Download',
              text: "Download",
              onClick: props.menuConfig.downloadFile,
              onRender: (item) => getMenuStyledRender(item, downloadIcon, props.menuConfig.downloadFile)
            })
          }
          
          if (!isPermissionTypeRead) {

            if (
              (isPermissionTypeOrganize || isPermissionTypeEdit) &&
              (props.menuConfig.validatioRuleConst == undefined || (props.menuConfig.validatioRuleConst != undefined && isReleaseConst))
            ) {
              if (isReleaseConst) {
                context.push({
                  key: 'set',
                  text: t("Item.setDraft"),
                  onClick: props.menuConfig.setDraft,
                  onRender: (item) => getMenuStyledRender(item, draftIcon, props.menuConfig.setDraft)
                })
              }
              else if (!isReleaseConst) {
                context.push({
                  key: 'set',
                  text: t("Item.setRelease"),
                  onClick: props.menuConfig.serRelease,
                  onRender: (item) => getMenuStyledRender(item, releaseIcon, props.menuConfig.serRelease)
                });
              }
              if(isUndoDraftIsOpen && !isReleaseConst){
                context.push({
                  key: 'UndoDraft',
                  text: t("Item.undoDraft"),
                  onClick: props.menuConfig.undoDraft,
                  onRender: (item) => getMenuStyledRender(item, unduDraftIcon, props.menuConfig.undoDraft)
                })
              }
            }

            if (isD4SignSignedConst) {
              context.push({
                key: 'set',
                text: t("Item.d4SignVersion"),
                onClick: props.menuConfig.ExibirItemD4SignTrue,
                onRender: (item) => getMenuStyledRender(item, d4signIcon, props.menuConfig.ExibirItemD4SignTrue)
              })
            }

            if(isReleaseConst == true && (isAdmin || isOwner))
            {        
                context.push({
                  key: 'Arquivar',
                  text: t("Arquivar.message"),
                  onClick: props.menuConfig.setArchiving,
                  onRender: (item) => getMenuStyledRender(item, {icon: ToFile, color:"rgb(45, 45, 45)"}, props.menuConfig.setArchiving, undefined, true, (props.menuConfig.existStorageArchive == undefined || props.menuConfig.existStorageArchive != true))
                })
            }
          }
          
          if(
            (isAdmin || isOwner))
          {
            context.push({
              key: 'Shared',
              text: t("SharedFile.Menu"),
              onClick: props.menuConfig.setShared,
              onRender: (item) => getMenuStyledRender(item, sharedFileIcon, props.menuConfig.setShared)
            })
          }
          if (window.navigator.userAgent.indexOf(OS_PLATFORM.WINDOWS) !== -1 && !isReleaseConst && props.menuConfig.validatioRuleConst == undefined && (isAdmin || isPermissionTypeEdit || isPermissionTypeOrganize))
          {
            context.push({
              key: 'OpenInWindows',
              text: t("DownloadAgentModal.openInApplication"),
              onClick: props.menuConfig.openFileInWindows,
              onRender: (item) => getMenuStyledRender(item, openAppIcon, props.menuConfig.openFileInWindows)
            })
          }
        }
        else if (isFolder && (isAdmin || isOwner)) {
          if (isAdmin || isOwner) {
            context.push({
              key: 'Editar',
              text: t("editItem.message"),
              onClick: props.menuConfig.setEditFolderOpen,
              onRender: (item) => getMenuStyledRender(item, editIcon, props.menuConfig.setEditFolderOpen)
            })

            context.push({
              key: 'CopyFolderStructure',
              text: t("DuplicateFolder.message"),
              onClick: props.menuConfig.openCopyFolderStructureDrawer,
              onRender: (item) => getMenuStyledRender(item, copyFolderStructureIcon, props.menuConfig.openCopyFolderStructureDrawer)
            })
          }
          else {
            context.push({
              key: 'Renomear',
              text: t("renameItem.message"),
              onClick: props.menuConfig.rename,
              onRender: (item) => getMenuStyledRender(item, editIcon, props.menuConfig.rename)
            })
          }

          if ((isAdmin || isOwner)) {
          context.push({
            key: 'Deletar Folder',
            text: t("Item.deleteBtn"),
            onClick: props.menuConfig.excluir,
            onRender: (item) => getMenuStyledRender(item, deleteicon, props.menuConfig.excluir)
          })
        }

          context.push({
            key: 'Mover',
            text: t("Move.message"),
            onClick: props.menuConfig.moveOpen,
            onRender: (item) => getMenuStyledRender(item, moveIcon, props.menuConfig.moveOpen)
          })
        }
      }
    }
    if (isFile) {
      context.push({
        key: 'CopyDocumentLink',
        text: t("CopyDocumentLink.message"),
        onClick: copyDocumentLinkUrl,
        onRender: (item) => getMenuStyledRender(item, biCopy, copyDocumentLinkUrl, documentLinkUrl)
      })
    }
 
    setMenuItems(context);
  }, [
    props.menuConfig.isD4SignSignedConst,
    props.menuConfig.validatioRuleConst,
    props.menuConfig.isReleaseConst,
    profile,
    props.menuConfig.permissionType,
    props.menuConfig.isAdmin,
    props.menuConfig.setArchiving,
    props.menuConfig.existStorageArchive,
    props.menuConfig.temporalityDocument
  ])

  const lessMargin = useLessMargin()

  function getMenuStyledRender(item: IContextualMenuItem, icon: IElementIcon | string | undefined, onClick: () => void, tooltipText?: string, widthStandar: boolean = true, disabled: boolean = false)
  {
      return <MenuStiledRenderProps
                item={item}
                widthStandar={widthStandar}
                disabled={disabled}
                src={typeof icon === "string" ? icon : undefined}
                elementIcon={typeof icon !== "string" ? icon : undefined}
                onClick={onClick}
                tooltipText={tooltipText}
              />
      
  }

  return (
    <div className={props.menuConfig.openViwer ? stylesList.marginMenu : undefined} ref={liRef}>
      {props.menuConfig.layoutPendencies ? (
        <div className={props.menuConfig.boxLayout ? lessMargin.myDiv : lessMargin.default}>
          {props.menuConfig.extension == "pdf" ? (
            <>
              <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={onShowContextualMenu}
                ref={linkRef}
                sx={{
                  padding: '0px'
                }}
              >
                <MoreVertIcon />
              </IconButton>
              <ContextualMenu
                items={menuItems}
                hidden={!showContextualMenu}
                target={linkRef}
                styles={{
                  root: {
                    paddingTop: "8px",
                    paddingBottom: "8px",
                    boxShadow: "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",
                  }
                }}
                onItemClick={onHideContextualMenu}
                onDismiss={onHideContextualMenu}
              />
            </>
          ) : (
            <div style={{ width: "40px" }}>

            </div>
          )}
        </div>
      ) : (
        <div>
          <IconButton
            aria-label="more"
            id="long-button"
            aria-controls={open ? 'long-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            onClick={onShowContextualMenu}
            ref={linkRef}
            sx={{
              padding:'0px'
            }}
          >
            <ThreeDotsIcon style={{
              height: "16px",
              width: "16px",
            }} />
          </IconButton>
          <ContextualMenu
            items={menuItems}
            hidden={!showContextualMenu}
            target={linkRef}
            styles={{
              subComponentStyles: {
                callout: {
                  root: {
                    boxShadow: 'none'
                  },
                  css: {
                    boxShadow: 'none'
                  }
                }
              }
            }}
            onItemClick={onHideContextualMenu}
            onDismiss={onHideContextualMenu}
            id="context_menu"
            calloutProps={{
              style: {
                right: '24px',
                boxShadow: "rgba(0, 0, 0, 0.133) 0px 3.2px 7.2px 0px, rgba(0, 0, 0, 0.11) 0px 0.6px 1.8px 0px",

              }
            }}
          />
        </div>
      )}
    </div>
  );
}

export default MenuCont;